// extracted by mini-css-extract-plugin
export default {"loader":"purchase-bill-project-item-select_loader__w5E9s","rotation":"purchase-bill-project-item-select_rotation__z38v2"};